import { Component } from '@angular/core';

@Component({
  selector: 'app-excluding-land-from-agricultural-production',
  templateUrl:
    './excluding-land-from-agricultural-production-portal.component.html',
  standalone: false,
})
export class ExcludingLandFromAgriculturalProductionPortalComponent {}
